module.exports = __webpack_public_path__ + "static/media/RealEstatePrices.b0db27a0.png";